/**
 * Product Inventory JS
 * Handles inventory status displays
 */

document.addEventListener('DOMContentLoaded', function() {
  initProductInventory();
  
  // Listen for variant change events from product-form
  document.addEventListener('variant:changed', handleVariantChanged);
});

function initProductInventory() {
  // Initialize all inventory elements on the page
  const inventoryElements = document.querySelectorAll('.product-inventory');
  inventoryElements.forEach(element => {
    // Store original templates from the server-rendered HTML
    element.originalContent = element.innerHTML;
    element.outTemplate = element.querySelector('.inventory--out')?.outerHTML;
    element.lowTemplate = element.querySelector('.inventory--low')?.outerHTML;
    element.inStockTemplate = element.querySelector('.inventory--in-stock')?.outerHTML;
    element.lowStockThreshold = parseInt(element.dataset.lowStock) || 10;
  });
}

function handleVariantChanged(event) {
  if (!event.detail || !event.detail.variant) return;
  
  // Find the closest inventory element
  const inventoryElement = event.target.closest('.product-form')?.querySelector('.product-inventory');
  if (!inventoryElement) return;
  
  updateInventory(inventoryElement, event.detail.variant);
}

function renderInventoryTemplate(element, template) {
  if (!template) return;

  element.innerHTML = template;
  element.firstElementChild?.removeAttribute('hidden');
}

function updateInventory(element, variant) {
  if (!variant || !variant.inventory_management) {
    // Show in-stock state
    renderInventoryTemplate(element, element.inStockTemplate);
    element.classList.add('product-inventory--in-stock');
    element.classList.remove('product-inventory--low', 'product-inventory--out');
    return;
  }
  
  const quantity = variant.inventory_quantity;
  
  if (quantity <= 0 && !variant.available) {
    // Out of stock
    if (element.outTemplate) {
      renderInventoryTemplate(element, element.outTemplate);
    } else {
      element.innerHTML = element.originalContent;
    }
    element.classList.add('product-inventory--out');
    element.classList.remove('product-inventory--low', 'product-inventory--in-stock');
  } 
  else if (quantity <= element.lowStockThreshold && quantity > 0) {
    // Low stock - replace count in the existing template
    if (element.lowTemplate) {
      const template = element.lowTemplate.replace(/\d+(?=\s+left)/, quantity);
      renderInventoryTemplate(element, template);
    }
    element.classList.add('product-inventory--low');
    element.classList.remove('product-inventory--out', 'product-inventory--in-stock');
  }
  else {
    // Plenty of stock
    renderInventoryTemplate(element, element.inStockTemplate);
    element.classList.add('product-inventory--in-stock');
    element.classList.remove('product-inventory--low', 'product-inventory--out');
  }
} 
